import { render, staticRenderFns } from "./AcceptedTypeAnswer.vue?vue&type=template&id=488fc37e&scoped=true"
import script from "./AcceptedTypeAnswer.vue?vue&type=script&lang=js"
export * from "./AcceptedTypeAnswer.vue?vue&type=script&lang=js"
import style0 from "./AcceptedTypeAnswer.vue?vue&type=style&index=0&id=488fc37e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488fc37e",
  null
  
)

export default component.exports